import AreaEdit from 'views/AreaEdit.vue'
import AreaOverview from 'views/AreaOverview.vue'

import CustomerEdit from 'views/CustomerEdit.vue'
import CustomerOverview from 'views/CustomerOverview.vue'

import Dashboard from 'views/Dashboard.vue'

import DeceasedEdit from 'views/DeceasedEdit.vue'
import DeceasedOverview from 'views/DeceasedOverview.vue'

import GraveEdit from 'views/GraveEdit.vue'
import GraveOverview from 'views/GraveOverview.vue'

import UserEdit from 'views/UserEdit.vue'
import UserOverview from 'views/UserOverview.vue'

import RoleEdit from 'views/RoleEdit.vue'
import RoleOverview from 'views/RoleOverview.vue'

import TemplateEdit from 'views/TemplateEdit.vue'
import TemplateOverview from 'views/TemplateOverview.vue'

import LoginView from 'views/LoginView.vue'
import LogoutView from 'views/LogoutView.vue'

import UndertakerOverview from 'views/UndertakerOverview.vue'
import UndertakerEdit from 'views/UndertakerEdit.vue'

import CrematoryOverview from 'views/CrematoryOverview.vue'
import CrematoryEdit from 'views/CrematoryEdit.vue'

import Profile from 'views/Profile.vue'

import NavView from 'views/NaviView.vue'

import CategoriesView from 'views/AreaCategories.vue'
import GraveTypesView from 'views/GraveTypes.vue'
import BurialTypesView from 'views/BurialTypes.vue'
import DenominationsView from 'views/Denomations.vue'
import GraveyardOverview from 'views/GraveyardOverview.vue'
import GraveyardEdit from 'views/GraveyardEdit.vue'

export default [
  { path: '/dashboard/', components: { default: Dashboard, navi: NavView }, key: 'dashboard', meta: { mode: 'page' }, name: 'dashboard' },

  { path: '/deceaseds/', components: { default: DeceasedOverview, navi: NavView }, key: 'deceaseds', meta: { mode: 'page' } },
  { path: '/deceaseds/new', components: { default: DeceasedEdit, navi: NavView }, key: 'deceased_new', meta: { mode: 'page' } },
  { path: '/deceaseds/:deceased_id', components: { default: DeceasedEdit, navi: NavView }, key: 'deceased_edit', meta: { mode: 'page' } },

  { path: '/customers/', components: { default: CustomerOverview, navi: NavView }, key: 'customers', meta: { mode: 'page' } },
  { path: '/customers/new', components: { default: CustomerEdit, navi: NavView }, key: 'customer_new', meta: { mode: 'page' } },
  { path: '/customers/:customer_id', components: { default: CustomerEdit, navi: NavView }, key: 'customer_edit', meta: { mode: 'page' } },

  { path: '/graves/', components: { default: GraveOverview, navi: NavView }, key: 'graves', meta: { mode: 'page' } },
  { path: '/graves/new', components: { default: GraveEdit, navi: NavView }, key: 'grave_new', meta: { mode: 'page' } },
  { path: '/graves/free', components: { default: GraveOverview, navi: NavView }, key: 'grave_new', meta: { mode: 'page' } },
  { path: '/graves/:id', components: { default: GraveEdit, navi: NavView }, key: 'grave_edit', meta: { mode: 'page' } },

  { path: '/users/', components: { default: UserOverview, navi: NavView }, key: 'users', meta: { mode: 'page' } },
  { path: '/users/new', components: { default: UserEdit, navi: NavView }, key: 'user_new', meta: { mode: 'page' } },
  { path: '/users/:id', components: { default: UserEdit, navi: NavView }, key: 'user_edit', meta: { mode: 'page' } },

  { path: '/roles/', components: { default: RoleOverview, navi: NavView }, key: 'roles', meta: { mode: 'page' } },
  { path: '/roles/new', components: { default: RoleEdit, navi: NavView }, key: 'role_new', meta: { mode: 'page' } },
  { path: '/roles/:id', components: { default: RoleEdit, navi: NavView }, key: 'role_edit', meta: { mode: 'page' } },

  { path: '/areas/', components: { default: AreaOverview, navi: NavView }, key: 'areas', meta: { mode: 'page' } },
  { path: '/areas/new', components: { default: AreaEdit, navi: NavView }, key: 'area_new', meta: { mode: 'page' } },
  { path: '/areas/:id', components: { default: AreaEdit, navi: NavView }, key: 'area_edit', meta: { mode: 'page' } },

  { path: '/undertakers/', components: { default: UndertakerOverview, navi: NavView }, key: 'undertaker', meta: { mode: 'page' } },
  { path: '/undertakers/new', components: { default: UndertakerEdit, navi: NavView }, key: 'undertaker_new', meta: { mode: 'page' } },
  { path: '/undertakers/:id', components: { default: UndertakerEdit, navi: NavView }, key: 'undertaker_edit', meta: { mode: 'page' } },

  { path: '/crematories/', components: { default: CrematoryOverview, navi: NavView }, key: 'crematories', meta: { mode: 'page' } },
  { path: '/crematories/new', components: { default: CrematoryEdit, navi: NavView }, key: 'crematory_new', meta: { mode: 'page' } },
  { path: '/crematories/:id', components: { default: CrematoryEdit, navi: NavView }, key: 'crematory_edit', meta: { mode: 'page' } },

  { path: '/profile/', components: { default: Profile, navi: NavView }, key: 'profile', meta: { mode: 'page' } },

  { path: '/templates/', components: { default: TemplateOverview, navi: NavView }, key: 'templates', meta: { mode: 'page' } },
  { path: '/templates/', components: { default: TemplateEdit, navi: NavView }, key: 'template_new', meta: { mode: 'page' } },
  { path: '/templates/', components: { default: TemplateEdit, navi: NavView }, key: 'template_edit', meta: { mode: 'page' } },

  { path: '/', components: { default: LoginView }, meta: { mode: 'login' } },
  { path: '/logout/', components: { default: LogoutView }, meta: { mode: 'logout' } },

  { path: '/area_types/', components: { default: CategoriesView, navi: NavView }, key: 'categories_view', meta: { mode: 'page' } },
  { path: '/grave_types/', components: { default: GraveTypesView, navi: NavView }, key: 'grave_types_view', meta: { mode: 'page' } },
  { path: '/burial_types/', components: { default: BurialTypesView, navi: NavView }, key: 'burial_types_view', meta: { mode: 'page' } },
  { path: '/denominations/', components: { default: DenominationsView, navi: NavView }, key: 'denominations_view', meta: { mode: 'page' } },

  { path: '/graveyards/', components: { default: GraveyardOverview, navi: NavView }, key: 'graveyards_view', meta: { mode: 'page' } },
  { path: '/graveyards/new', components: { default: GraveyardEdit, navi: NavView }, key: 'graveyards_view', meta: { mode: 'page' } },
  { path: '/graveyards/:id', components: { default: GraveyardEdit, navi: NavView }, key: 'graveyards_view', meta: { mode: 'page' } },

  { path: '*', redirect: '/' }
]



// WEBPACK FOOTER //
// ./src/routes.js